/**
 * A NYITÓ-HÁROMSZÖG — a saját, egyetlen ikonunk (#49).
 *
 * ⚠️ MIÉRT NEM `▸`/`▾` KARAKTER. A szöveges háromszög a BETŰTÍPUSBÓL jön: más
 * a mérete, más az alapvonala, és gépenként más is lehet, ha a font nem
 * tartalmazza. Ez nem elméleti — a cégfejléc igazítási hibájának egy része
 * pont ebből jött (`app.css`, „nem volt minden egy szinten"). Egy SVG mérete
 * és helye a MIÉNK.
 *
 * ⚠️ MIÉRT NEM IKONKÖNYVTÁR. Ma egyetlen ikon kell, és a `design-brief.md`
 * nem-célja kimondja: *„lekerekített kártyák mindenhol, dekoratív ikonok"* —
 * nem ikonos felületet építünk, a sűrűség a fontosabb. Egy csomag ezért
 * aránytalan lenne. *(Viktor, 2026-09-18.)*
 *
 * A GEOMETRIA VISZONT SZABVÁNYOS: 24×24-es rács, `currentColor`. Ez a Tabler
 * és a Lucide rácsa is (az SP házi készlete Tabler-alapú, `caret-down-filled`
 * néven ugyanez az ikon) — ha egyszer tényleg sok ikon kell, a csere ennek az
 * egy fájlnak a kidobása, nem átrajzolás.
 */

export function Caret({ open }: { open: boolean }) {
  return (
    // `aria-hidden`: a NYITOTTSÁGOT az `aria-expanded` mondja el a
    // képernyőolvasónak, a háromszög a szemnek szól. Kimondva kétszer
    // hangzana el ugyanaz.
    <svg
      className={open ? 'caret caret--open' : 'caret'}
      viewBox="0 0 24 24"
      width="12"
      height="12"
      aria-hidden="true"
      focusable="false"
    >
      {/* Lefelé mutató tömör háromszög; csukott állapotban a CSS forgatja
          jobbra. EGY alakzat, két állapot — két külön path esetén a kettő
          előbb-utóbb elcsúszna egymástól. */}
      <path d="M7 9.5h10L12 16z" fill="currentColor" />
    </svg>
  );
}
